import * as React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { CourseProviderData, CourseProviderEdit } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface CPInvoiceDataProps {
    courseProvider: CourseProviderEdit;
    courseProviderData: CourseProviderData;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    saveInvoiceData: (a: string) => void;
}

export interface CPInvoiceDataState {
    vat: string;
}

export default class CPInvoiceData extends React.PureComponent<CPInvoiceDataProps, CPInvoiceDataState> {
    constructor(props: CPInvoiceDataProps) {
        super(props);
        this.state = {
            vat: '',
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            vat: this.props.courseProvider.Vat,
        });
    }

    public render() {
        const { vat } = this.state;
        return (
            <CPItemEditComponent
                name={TR.cPInvoiceData_invoicing_terms}
                editHandler={this.props.editHandler}
                saveHandler={() => this.props.saveInvoiceData(vat)}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.InvoiceData) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (this.props.courseProvider.Vat === '') {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.cPInvoiceData_missing_data} />
                </Col>
            );
        } else {
            return (
                <>
                    <Col md={4}>
                        <div className="mb-1 mt-1">{TR.cPInvoiceData_modalities}</div>
                    </Col>
                    <Col md={8}>
                        <div className="mb-1 mt-1">
                            {this.props.courseProvider.Vat === 'true'
                                ? TR.cPInvoiceData_vat_yes
                                : TR.cPInvoiceData_vat_no}
                            , {TR.cPInvoiceData_commision_fee}&nbsp;
                            {this.props.courseProviderData.Commission}&nbsp;%
                        </div>
                    </Col>
                </>
            );
        }
    };

    private renderContentEdit = () => {
        return (
            <>
                <Row>
                    <Col md={12} className="mt-1 mb-2">
                        {TR.cPInvoiceData_I_am}
                    </Col>
                    <Col md={12} className="mt-1 mb-2">
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="true"
                                    value="umsatzsteuerpflichtig"
                                    onChange={this.inputHandler}
                                    checked={this.state.vat === 'true'}
                                />{' '}
                                {TR.cPInvoiceData_vat_yes}
                            </Label>
                        </FormGroup>
                        <FormGroup check={true}>
                            <Label check={true}>
                                <Input
                                    type="radio"
                                    name="false"
                                    value="umsatzsteuerbefreit"
                                    onChange={this.inputHandler}
                                    checked={this.state.vat === 'false'}
                                />{' '}
                                {TR.cPInvoiceData_vat_no}
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col md={12}>
                        <span style={{ fontSize: '14px', color: '#666' }}>{TR.cPInvoiceData_not_visible}</span>
                    </Col>
                </Row>
            </>
        );
    };
    private inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedOption = e.target.value;
        if (selectedOption === 'umsatzsteuerpflichtig') {
            this.setState({ vat: 'true' });
        }
        if (selectedOption === 'umsatzsteuerbefreit') {
            this.setState({ vat: 'false' });
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPInvoiceData.tsx